
import { handleActions } from 'redux-actions';
import range from 'lodash/range';
import { FETCH_TICKETS_REQUEST, FETCH_TICKETS_SUCCESS, FETCH_TICKETS_FAILURE } from './constants';

const yearNow = new Date().getFullYear();
const initialState = {
  payTickets: {
    initialized: false,
    initializing: false,
    initializeFailed: false,
    error: null,
    hasError: false,
    loaded: false,
    loading: false,
    paytickets: [],
    payticketsLoaded: false,
    payYear: yearNow,
    payYearOptions: range(2010, yearNow + 1),
  },
};

export default handleActions({
  [FETCH_TICKETS_REQUEST]: state => ({
    ...state,
    fetchingEntries: true,
    error: '',
    hasError: false,
    loading: true,
  }),
  [FETCH_TICKETS_SUCCESS]: (state, { paytickets, orgCompanyIds }) => ({
    ...state,
    paytickets,
    orgCompanyIds,
    loading: false,
  }),
  [FETCH_TICKETS_FAILURE]: (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
    hasError: true,
  }),
}, initialState.payTickets);



// WEBPACK FOOTER //
// ./src/sites/payTickets/reducer.js